import React from "react";
import { Link } from "react-router-dom";

function Calltoaction() {
  return (
    // Call To Action Section
    <section
      id="call-to-action"
      className="call-to-action section accent-background"
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="text-center">
              <h1>We do whatever it takes to bring you peace of mind</h1>

              <a href="https://wa.me/+447802416170" target="_blank">
                <p className="pp">
                  <i className="bi bi-whatsapp whats"></i>
                  Looking for care ?
                </p>
              </a>
              <Link to="/form">
                <a className="cta-btn" href="">
                  REQUEST A CALLBACK
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
    // /Call To Action Section
  );
}

export default Calltoaction;
